export default __webpack_public_path__ + "static/media/photo--lg--80.12e0b9e9.jpg";